import { useMemo } from 'react';
import { useEffectiveWatermarkQuery } from '@/generated/graphql';
import { gqlToWatermarkConfig, type CampaignWatermarkGql, type WatermarkConfig } from '@/lib/campaign-watermark-types';

/**
 * Returns the campaign watermark config for a project, or null if there is
 * no effective campaign override. When `projectDocumentId` is falsy, the
 * query is skipped and `null` is returned.
 */
export const useEffectiveWatermark = (
  projectDocumentId: string | null | undefined,
): WatermarkConfig | null => {
  const { data } = useEffectiveWatermarkQuery({
    variables: { id: projectDocumentId || '' },
    skip: !projectDocumentId,
    fetchPolicy: 'cache-first',
  });

  return useMemo(() => {
    const wm = data?.myProject?.effective_watermark;
    if (!wm) return null;
    return gqlToWatermarkConfig(wm as CampaignWatermarkGql);
  }, [data?.myProject?.effective_watermark]);
};
